export function ValidateAlphanumericWithDash(event) 
{
  const key = event.key;
  
  // allow navigation / editing keys
  if (
    key === "Backspace" || 
    key === "Delete" || 
    key === "ArrowLeft" || 
    key === "ArrowRight" 
  ) {
    return true;
  }

  var inp = String.fromCharCode(event.keyCode);

  if (/[a-zA-Z0-9-]/.test(inp)) {
    return true;
  } else {
    event.preventDefault();
    return false;
  }
}